import React from 'react';
import img000 from '../components/images/sample.png';
import img2049 from '../components/images/rjiomart.jpg';

const Events = () => {
    return (
        <>
            <div className="row m-2">
                <img className="img-fluid" src={img2049} alt="jiomart" />
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <h2>Why JioMart Registration is Essential</h2>
                        <p>
                            JioMart registration is essential for businesses looking to access a vast customer base,
                            enhance brand credibility, and utilize advanced logistics and marketing tools provided by Jio.
                        </p>
                    </div>
                    <div className="col-12 col-md-6">
                        <img className="img-fluid" src={img000} alt="Queryimg" />
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12 col-md-6">
                        <h2>Essential Details Required:</h2>
                        <ul className="list-group">
                            <li className="list-group-item"><strong>Email ID:</strong> Essential for account setup and communication purposes.</li>
                            <li className="list-group-item"><strong>Contact Number:</strong> Needed for verification and customer interaction.</li>
                            <li className="list-group-item"><strong>GST Certificate:</strong> Validates your business and ensures tax compliance.</li>
                            <li className="list-group-item"><strong>Pickup Address:</strong> Required for seamless product pickups and order fulfillment.</li>
                            <li className="list-group-item"><strong>Bank Details:</strong> Necessary for secure payment transactions.</li>
                            <li className="list-group-item"><strong>Product Category:</strong> Helps categorize your products for optimal visibility on JioMart.</li>
                            <li className="list-group-item"><strong>Trademark:</strong> Protect your brand identity with registered trademarks, ensuring legal rights and brand recognition on the platform.</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-6">
                        <img className="img-fluid" src={img000} alt="Queryimg" />
                    </div>
                </div>

                <p className="mt-4">
                    <strong>Get started now</strong> and expand your business on a trusted platform. Contact us at E Seller Support for assistance.
                </p>
            </div>
        </>
    );
};

export default Events;
